import * as fromOpcDSActions from '../../../actions/AdmMapa/Cartografia/OpcionSelect.actions';


export interface OpcionDSState {
    OActiva: string;
}

const initialStateDS: OpcionDSState = {
    OActiva: ''
};

export function opcionDSReducer(state = initialStateDS, action: fromOpcDSActions.OpcionDSActions): OpcionDSState {
    switch (action.type) {
        case fromOpcDSActions.ACTIVAR_ODS:
            return {
                ...state,
                OActiva: action.opcion
            };
      default: {
        return state;
      }
    }
}
